import { AlertTriangle, Info } from 'react-feather'
import styled from 'styled-components'

import * as S from './styled'

const IconWrapper = styled.div`
  flex-shrink: 0;
`

type BannerSize = 'small' | 'large'

const BANNER_MESSAGES = {
  multipleCategoriesFound: 'We found results in multiple categories:',
  noResultsButSuggesting: "We didn't find anything, but maybe you'll find what you need here:",
  noResultsEvenWithoutFilters: "We didn't find anything even without filters",
} as const

const ICON_SIZES: Record<BannerSize, number> = {
  small: 13,
  large: 16,
} as const

const getSmallBannerStyles = () => ({
  padding: '8px',
  fontSize: '12px',
  lineHeight: '12px',
  marginBottom: 0,
  minHeight: '36px',
})

const getBannerMessage = (hasResults: boolean, hasMultipleCategoryResults?: boolean): string => {
  if (!hasResults) {
    return BANNER_MESSAGES.noResultsEvenWithoutFilters
  }

  return hasMultipleCategoryResults ? BANNER_MESSAGES.multipleCategoriesFound : BANNER_MESSAGES.noResultsButSuggesting
}

export default function SearchBanner({
  hasResults,
  size = 'large',
  hasMultipleCategoryResults,
}: {
  hasResults: boolean
  size?: BannerSize
  hasMultipleCategoryResults?: boolean
}) {
  const isSmallSize = size === 'small'
  const iconSize = ICON_SIZES[size]
  const bannerMessage = getBannerMessage(hasResults, hasMultipleCategoryResults)

  const bannerStyles = isSmallSize ? getSmallBannerStyles() : undefined

  return (
    <S.BannerWrapper style={bannerStyles}>
      {hasResults ? (
        <IconWrapper
          style={{
            marginTop: isSmallSize ? '2px' : 0,
          }}
        >
          <Info size={iconSize} />
        </IconWrapper>
      ) : (
        <AlertTriangle size={iconSize} />
      )}
      {bannerMessage}
    </S.BannerWrapper>
  )
}
